import Vue from 'vue'
import Router from 'vue-router'
import home from './home/home'
import solve from './solve/solve'
import course from './course/course'
import customer from './customer/sustomer'
import understand from './understand/understand'
import product from './product/product'

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.place;
Router.prototype.place = function place(location) {
    return originalReplace.call(this, location).catch(err => err)
}

const routes = [
    ...home,
    ...solve,
    ...course,
    ...customer,
    ...understand,
    ...product
]

const router = new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({
        y: 0
    }),
    routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js